<template>
  <div class="authWrapper new-login-wrapper">
    <div class="container">
      <div class="row whiteBG-wrap login-white-wrap">
        <div class="col-lg-7 col-md-7 no-padding">
          <div class="login-left-wrap">
            <div class="back-icon text-start">
              <router-link to="/login" class="ms-0 p-0">Back</router-link>
            </div>
            <div class="rep-icon-login">
              <img
                src="../../../assets/images/group-icon.svg"
                alt="image-fluid"
              />
            </div>
            <h4 class="mb-4 ms-2">Login with QR</h4>
            <div v-if="showSpinnerLoader">
              <!-- <spinners-loader /> -->
            </div>
            <div class="auth-form-wrap login-smart-qr" v-else>
              <div>
                <div class="qr-image-container">
                  <img :src="QRUrl" class="mb-1" v-if="QRUrl" />
                </div>
                <div class="overlay" v-if="!isQrCodeValid">
                  <div class="retry-wrap" @click="regenerateQRCode">
                    <img
                      src="../../../assets/images/regenerate.svg"
                    />Regenerate <br />
                    QR Code
                  </div>
                </div>
                <div v-else>
                  <!-- <OTPTimer title=""
                            @sendOTP="getQR"
                            @updateRemainingSecond="updateRemainingSecond"
                            :expirySecond=180 /> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-5 col-md-5 no-padding">
          <div class="rep-dash-bg pt-3">
            <div class="">
              <img
                src="../../../assets/images/mobile-ss.png"
                class="mobile-screen"
              />
            </div>
            <div class="qr-login-list">
              <h4>Use Group dashboard on web:</h4>
              <ul class="">
                <li>Open Group App on your phone.</li>
                <li>
                  Tap QR Menu
                  <img
                    src="../../../assets/images/qr-icon.svg"
                    alt="qr icon"
                    class="me-2 ms-2 qr-icon-bg"
                  />
                  located on top right of Group App
                </li>
                <li>Point your phone to this screen to capture the QR code.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import helper from "@/resource/Helper";
import store from "@/store";
// import OTPTimer from "@/components/ui/QROTPTimmer";
// import SpinnersLoader from "../../components/ui/SpinnersLoader";
export default {
  name: "SmartLogin",
  components: {
    // OTPTimer,
    // SpinnersLoader
  },
  data() {
    return {
      form: {
        username: "",
        password: "",
        deviceID: "",
      },
      loginLoader: false,
      formErrorFlag: false,
      formErrors: [],
      QRUrl: "",
      socket: null,
      message: "",
      messages: [],
      isQrCodeValid: false,
      showSpinnerLoader: false,
    };
  },
  mounted() {
    let deviceID = this.$store.getters.deviceId
      ? this.$store.getters.deviceId
      : this.$uuid.v1();
    let uniqueID = this.$uuid.v1();
    this.$store.commit("setDeviceId", deviceID);
    this.$store.commit("setUniqueID", uniqueID);
    this.getQR(this.$store.getters.uniqueID, this.$store.getters.deviceId);
    this.setupWebSocket();
  },
  methods: {
    getQR(code, deviceID) {
      this.showSpinnerLoader = true;
      this.isQrCodeValid = false;
      axios
        .get(
          `v2/auth/get-user-login-sync?unique_auth_id=${code}&device_id=${deviceID}`
        )
        .then((res) => {
          this.QRUrl = res.data.data.url;
          this.isQrCodeValid = true;
        })
        .catch((error) => {
          if (
            error.response &&
            error.response.data &&
            error.response.data.status === "error"
          ) {
            this.isQrCodeValid = false;
            let app = this;
            helper.infoMessage(
              app,
              error.response.data.status,
              error.response.data.message
            );
          }
        })
        .finally(() => {
          this.showSpinnerLoader = false;
        });
    },
    updateRemainingSecond(value) {
      let app = this;
      let remaningSecond = value;
      remaningSecond <= 0 && (app.isQrCodeValid = false);
    },
    regenerateQRCode() {
      let app = this;
      app.getQR(this.$store.getters.uniqueID, this.$store.getters.deviceId);
    },
    runPoll() {
      this.checkRepAuthentication(
        this.$store.getters.uniqueID,
        this.$store.getters.deviceId
      );
    },

    setupWebSocket() {
      this.socket = new WebSocket(
        `${this.$endpoint.WEB_SOCKET_URL}?device_id=${this.$store.getters.deviceId}`
      );
      this.socket.onopen = () => {
        console.log("WebSocket connection opened");
      };
      this.socket.onmessage = (event) => {
        console.log("event", event);
        const data = JSON.parse(event.data);
        console.log("data", data);
        if (data.event_type == "qr-login" && data.status == "success") {
          console.log(data);
          this.runPoll();
        }
      };
      this.socket.onclose = () => {
        console.log("WebSocket connection closed");
      };
    },
    checkRepAuthentication: async (uniqueID, deviceID) => {
      console.log("inside poll api 11");
      try {
        const response = await axios.get(
          `v2/auth/check-login-authentication?unique_auth_id=${uniqueID}&device_id=${deviceID}`
        );
        if (response.data.status) {
          console.log("inside poll api 12", response.data.status);
          store.commit("setAuthentication", true);
          helper.setLoginData(response.data);
          location.href = "/";
        }
      } catch (error) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.status === "error"
        ) {
          let app = this;
          helper.infoMessage(
            app,
            error.response.data.status,
            error.response.data.message
          );
        }
      }
    },
  },
};
</script>
<style src="@/assets/css/authen.css"></style>
<style src="@/assets/css/newLogin.css"></style>

<style>
#label-username,
#label-password {
  font-size: 16px !important;
  color: #909090 !important;
  margin-bottom: 10px !important;
}
#username,
#password {
  font-size: 14px !important;
  padding: 12px 15px !important;
}
.rep-icon-login {
  width: 80px;
}
.rep-icon-login img {
  width: 100px;
}
</style>
  
    